module.exports = __webpack_public_path__ + "img/metro-news2.9f56dc49.jpeg";